export default [
  {
    path: "/geography",
    name: "geography",
    component: () => import("./pages/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "География АЗС",
    },
  },
];
